import { useEffect, useState } from 'react';
import { getMonthlyTrend } from '../services/statsService';

// Monthly collected/disbursed totals for a school year start year. Pass null to skip.
export function useAdminTrend(schoolYear) {
  const [points, setPoints] = useState([]);
  const [loading, setLoading] = useState(schoolYear != null);

  useEffect(() => {
    // Keep the previous points while reloading so the chart can dim instead of flashing empty.
    if (schoolYear == null) {
      setPoints([]);
      setLoading(false);
      return undefined;
    }

    let mounted = true;
    setLoading(true);

    getMonthlyTrend(schoolYear)
      .then((data) => {
        if (mounted) setPoints(data);
      })
      .catch(() => {
        if (mounted) setPoints([]);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [schoolYear]);

  return { points, loading };
}
